
import React, { Component } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';


const benefitsData = [
  {
    title: "Increase Efficiency",
    description: "KlinicQ improves the efficiency of healthcare services by streamlining administrative tasks and optimizing workflows.",
    image: require("../../src/assets/images/website/benefits1.png"),
  },
  {
    title: "Increased Revenue",
    description: "KlinicQ helps increase your revenue by providing better patient experiences and reducing operational costs.",
    image: require("../../src/assets/images/website/benefits2.png"),
  },
  {
    title: "Patient Satisfaction",
    description: "KlinicQ enhances patient satisfaction by ensuring seamless communication and reducing wait times.",
    image: require("../../src/assets/images/website/benefits9.jpg"),
  },
  {
    title: "Reduce Exponential Expenses",
    description: "KlinicQ provides cost-effective solutions that help you minimize operational expenses.",
    image: require("../../src/assets/images/website/benefits10.jpg"),
  },
  {
    title: "Reduce Wait Time",
    description: "KlinicQ reduces wait times by optimizing scheduling and improving patient flow.",
    image: require("../../src/assets/images/website/benefits5.png"),
  },
  {
    title: "Comprehensive Solution",
    description: "KlinicQ offers a comprehensive solution to meet all your healthcare management needs.",
    image: require("../../src/assets/images/website/benefits6.png"),
  },
];

class SlidingBenefits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.nextSlide();
    }, 10000); // Change slide every 10 seconds
  }

  componentWillUnmount() {
    clearInterval(this.interval); // Cleanup on unmount
  }

  nextSlide = () => {
    this.setState((prevState) => ({
      currentIndex: (prevState.currentIndex + 1) % benefitsData.length,
    }));
  }

  prevSlide = () => {
    this.setState((prevState) => ({
      currentIndex: (prevState.currentIndex - 1 + benefitsData.length) % benefitsData.length,
    }));
  }

  render() {
    const { currentIndex } = this.state;
    return (
      <div className='company-section5 container-90'>
        <div className='d-flex justify-content-center flex-column align-items-center'>
          <div className='col-12'>
            <h3 className='text-center'>Why KlinicQ?</h3>
            <p className='intro-text5'>
              Transform Your Practice, Elevate Patient Care.
              <br />
              In today's fast-paced healthcare environment, efficiency, patient satisfaction, and cost-effectiveness are paramount.<br /> KlinicQ is designed to address these critical needs, empowering your practice to thrive.
            </p>
            <div className='slide-container5'>
              {benefitsData.map((benefit, index) => (
                <div key={index} className={`slide5 ${index === currentIndex ? 'active' : ''}`}>
                  <div className='text-section5'>
                    <h3 className='title5'>{benefit.title}</h3>
                    <p className=''>{benefit.description}</p>
                  </div>
                  <div className='image-section5'>
                    <img src={benefit.image} alt={benefit.title} className="benefit-image5" />
                  </div>
                </div>
              ))}
            </div>
            <div className='navigation-container5'>
              <FaArrowLeft className='arrow-left' onClick={this.prevSlide} />
              <div className='dots-container5'>
                {benefitsData.map((_, index) => (
                  <span key={index} className={`dot5 ${index === currentIndex ? 'active' : ''}`}></span>
                ))}
              </div>
              <FaArrowRight className='arrow-right' onClick={this.nextSlide} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SlidingBenefits;
